// Thin wrapper around GTM's dataLayer. Safe to call even before GTM's own
// snippet has run (e.g. a form submits before header_code has loaded, or
// before the admin has pasted a GTM snippet in at all) — window.dataLayer is
// lazily created here exactly like GTM's own snippet does
// (`window.dataLayer = window.dataLayer || []`), so events pushed early are
// simply queued and GTM drains them once it loads.
export function trackEvent(eventName, data = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...data });
}

// Delegated click listener for tel: links — attached once, globally, so it
// covers every phone number on the site (including ones rendered later,
// e.g. inside a modal) without needing to touch each component that renders
// a phone number individually.
let phoneTrackingAttached = false;
export function attachPhoneClickTracking() {
  if (phoneTrackingAttached || typeof document === 'undefined') return;
  phoneTrackingAttached = true;
  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (!link) return;
    trackEvent('phone_click', { phone_number: link.getAttribute('href').replace('tel:', '') });
  });
}
